import { render, staticRenderFns } from "./SubmissionResult.vue?vue&type=template&id=f526a1d6&scoped=true&"
import script from "./SubmissionResult.vue?vue&type=script&lang=js&"
export * from "./SubmissionResult.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionResult.vue?vue&type=style&index=0&id=f526a1d6&scoped=true&lang=css&"
import style1 from "./SubmissionResult.vue?vue&type=style&index=1&id=f526a1d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f526a1d6",
  null
  
)

export default component.exports